<template>
  <div id="app">
    <el-container>
      <el-header class="div-header">
        <Header />
        <el-divider class="header-divider"></el-divider>
      </el-header>

      <div class="main-div">
        <el-container class="main-div parentDiv">
          <splitpanes class="default-theme defaultStyle custom-splite">
            <pane size="100" class="SideBarLeft">
              <!--SID1037 Body Part -->
              <template>
                <el-container class="SID0015__InquiryCondition0015">
                  <div class="SID0015__Container">
                    <!-- Breadcrumb section -->
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                      <el-breadcrumb-item :to="{ path: '0002' }">トップ(記事一覧)</el-breadcrumb-item>
                      <el-breadcrumb-item :to="{ path: '0014' }">原文利用実績：照会条件設定</el-breadcrumb-item>
                      <el-breadcrumb-item :to="{ path: '' }">原文利用実績：照会結果ー期間集計</el-breadcrumb-item>
                    </el-breadcrumb>
                    <div>
                      <span class="Inquiry__condition">照会条件</span>
                    </div>
                    <div>
                      <el-divider class="result-main-divider"></el-divider>
                    </div>
                    <el-container>
                      <div class="resultDiv">
                        <el-form ref="form" :model="form" class="div-result" label-width="auto">
                          <el-form-item label="集計対象 ">
                            <span>{{ this.$route.params.data.AggregationconditionUser_id}}</span>
                          </el-form-item>
                          <el-form-item label="集計方法">
                            <span>{{ getFormPeriod }}</span>
                          </el-form-item>
                          <el-form-item label="集計期間 ">
                            <span>{{ this.$route.params.data.startDate }}~{{ this.$route.params.data.endDate }}</span>
                          </el-form-item>
                        </el-form>
                      </div>
                    </el-container>

                    <el-container>
                      <el-table
                        :data="getTableResult0015"
                        :span-method="arraySpanMethod"
                        style="width: 100%"
                      >
                        <el-table-column prop="user_group_name" label="ユーザーグループID" min-width="180"></el-table-column>
                        <el-table-column prop="user_id" label="ユーザーID" min-width="190"></el-table-column>
                        <el-table-column prop="process_date" label="利用年月日" min-width="160"></el-table-column>
                        <el-table-column label="ELNET" min-width="auto">
                          <el-table-column label="原文">
                            <el-table-column prop="pdf_count" label="表示"></el-table-column>
                            <el-table-column prop="print_count" label="印刷"></el-table-column>
                          </el-table-column>
                          <el-table-column label="テキスト本文">
                            <el-table-column prop="text_disp_count" label="表示"></el-table-column>
                            <el-table-column prop="text_print_count" label="印刷"></el-table-column>
                          </el-table-column>
                          <el-table-column prop="mc_count" label="小計"></el-table-column>
                        </el-table-column>
                        <el-table-column label="日経" min-width="auto">
                          <el-table-column prop="sc_text_count" label="テキスト"></el-table-column>
                          <el-table-column prop="sc_count" label="原文"></el-table-column>
                        </el-table-column>
                        <el-table-column label="合計" prop="count" min-width="auto"></el-table-column>
                      </el-table>
                    </el-container>
                    <el-row class="ButtonDiv">
                      <el-button type="info" @click="gofrom0015" plain>戻る</el-button>
                    </el-row>
                  </div>
                </el-container>
              </template>
              <!--SID1037 Body Part End-->
            </pane>
            <pane class="SideBarRight">
              <SideBar class="SidePane" />
            </pane>
          </splitpanes>
        </el-container>
      </div>

      <el-container class="footer-div">
        <el-footer class="footer-element">
          <FooterComponent />
        </el-footer>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import Header from "../common/header.vue";
import SideBar from "../common/side-bar.vue";
import FooterComponent from "../common/footerComponent.vue";
import { mapGetters } from "vuex";
import router from "../../router";


// In your VueJS component.
import { Splitpanes, Pane } from "splitpanes";
import "splitpanes/dist/splitpanes.css";

export default {
  name: "SID0015",
  components: {
    Header,
    SideBar,
    FooterComponent,
    Splitpanes,
    Pane
  },
  data() {
    return {
      form: {},
      userId: '',
    };
  },
  methods: {
    //for merging the table coloum as per the req
    arraySpanMethod({ rowIndex, columnIndex }) {
   
      if (rowIndex === (this.getRowCount - 1)) {
        if (columnIndex === 0) {
          return [1,3];
        } else if (columnIndex === 1) {
          return [0,0];
        } else if (columnIndex === 2) {
          return [0,0];
        }
      }
    },
    gofrom0015() {
      this.$LogButtonEvent("0015","Return");
			this.$LogMethodIN("0015","gofrom0015");
      router.push({ name: "SID0014" });
      this.$LogMethodOut("0015","gofrom0015");
    }
  },
  computed: {
    ...mapGetters("situation0015", [
      "getTableResult0015",
      "getFormUser",
      "getFormMethod",
      "getFormPeriod",
      "getFormTitle",
      "getFormCondition",
      "getUserGroupId",
      "getRowCount"
    ]),
    ...mapGetters("situation0001", [     
            "getUserId",
            "getContractId",
            "getUserGroupName"
        ])
  }, 
  mounted() {
    var articleValues = {
            contract_id: this.getContractId, 
            user_id: this.getUserId,
            user_group_name: this.getUserGroupName,            
            start_day:this.$route.params.data.startDate,
            end_day:this.$route.params.data.endDate
        };

        //Fix for BT08460_EXTERNAL-1557
        this.$store.commit('situation0015/setArticlesList', []);
        this.$store.commit('situation0015/setRowCount', '');
     
    //Get table articles during page load
    this.$store.dispatch('communication0015/getArticleList',articleValues);

  },
  created() {
    //For the screen Title
     document.title = "記事閲覧";
    var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    if (isMobile) {
        this.$router.push('sp/0015');
    }
    else{
        this.$router.push('/0015');
    }

    

  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "0015.css";
</style>